import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


export const createPhonecentersSysModel = ( {data} : {data: IPostNewPhonecentersSysModel | {}}): Promise<string> => {
  return axiosDefaultApi.post(`/api/PhonecentersSysModels/InsertPhonecentersSysModel`, data);
};

type QueryFnType = typeof createPhonecentersSysModel;

type UseCreatePhonecentersSysModelOptions = {
  data: IPostNewPhonecentersSysModel | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreatePhonecentersSysModel = ({ config }: UseCreatePhonecentersSysModelOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία του Μοντέλου.`, 500);
            console.error('Couldnt create new PhonecentersSys model', error);
            setIsNotificationVisible(true)
          },
          onSuccess: (response) => {
            queryClient.invalidateQueries(["getAllPhonecentersSysModels"])
            addNotification("Δημιουργήθηκε Νέο Μοντέλο.", 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createPhonecentersSysModel,
    })
}